module.exports = __webpack_public_path__ + "img/LNB_group.57fc3317.svg";